"use client";

import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { APP_NAME } from "@/lib/constants";
import { SquareArrowOutUpRightIcon } from "lucide-react";

const CustomPaymentLinkAlertDialog = ({
	price,
	period,
	onConfirm,
}: {
	price: JSX.Element;
	period: JSX.Element | null;
	onConfirm: () => void;
}) => {
	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<button className="group flex w-full items-center justify-between gap-1 rounded-md bg-brand-primary px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 disabled:opacity-50 md:w-44">
					<span className="text-white/90 transition-colors duration-300 group-hover:text-white">
						Join
					</span>

					<div className="flex items-center space-x-1 whitespace-nowrap">
						{price}

						{period}

						<SquareArrowOutUpRightIcon className="h-4 w-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
					</div>
				</button>
			</AlertDialogTrigger>

			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Notice: External Payment Link</AlertDialogTitle>
					<AlertDialogDescription>
						You are about to proceed to a custom payment link set by the admin. Please note:
					</AlertDialogDescription>

					<ul className="list-disc space-y-2 pl-4">
						<li>This payment is processed outside of {APP_NAME}.</li>
						<li>{APP_NAME} does not control or manage this transaction.</li>
						<li>
							The admin is solely responsible for granting you access to the community after
							payment.
						</li>
						<li>Before proceeding, we recommend confirming the payment details with the admin.</li>
					</ul>
				</AlertDialogHeader>

				<AlertDialogFooter>
					<AlertDialogCancel>Cancel</AlertDialogCancel>
					<AlertDialogAction className="text-red-500" asChild>
						<button type="button" onClick={onConfirm}>
							Confirm
						</button>
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};

export default CustomPaymentLinkAlertDialog;
